import {type BaseError} from '../../../../shared/errors/BaseError.ts'
import {ErrorTypes} from '../../../../shared/errors/ErrorEnums.ts'
import {type ErrorAuth, type ErrorBlocking, type ErrorMustBeMember} from '../../../../shared/errors/Errors.ts'
import {type TranslationObject} from '@colonist/i18n'
import {ViewPopupLogin} from '../ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts'
import {ViewPopup} from '../ui_popup/ViewPopup.ts'
import {type ViewPopupOptions} from '../ui_popup/ViewPopupOptions.ts'
import {UIDeviceController} from '../ui_html/UIDeviceController.ts'
import {navigateToPage} from '../ui_utils/ClientUtils.ts'

export class UIErrorHandler {
    private static currentPopup: ViewPopup | undefined

    static handleError(error: BaseError) {
        switch(error.type) {
            case ErrorTypes.DefaultError: this.showDefaultErrorPopup(error); break
            case ErrorTypes.AuthError: this.showAuthErrorPopup(error as ErrorAuth); break
            case ErrorTypes.MustLogin: new ViewPopupLogin(); break
            case ErrorTypes.MustBeMember: this.showMustBeMemberPopup(error as ErrorMustBeMember); break
            case ErrorTypes.Blocking: this.showBlockingPopup(error as ErrorBlocking); break
        }
    }

    static showDefaultErrorPopup(error: BaseError) {
        const defaultError: TranslationObject = {key: 'strings:popups.errors.general.title'}
        const title = error.title ?? defaultError
        const message = error.description

        const checkAction = () => undefined
        const xAction = () => undefined
        const canCancel = true

        const popup = new ViewPopup(title, message, checkAction, xAction, canCancel)

        if(this.isSameErrorAlreadyBeingShown(popup)) return

        popup.show()
        popup.removeXButton()
        this.currentPopup = popup
    }

    static showAuthErrorPopup(error: ErrorAuth) {
        const defaultError: TranslationObject = {key: 'strings:popups.errors.general.title'}
        const title = error.title ?? defaultError
        const message = error.getDisplayMessage()

        const checkAction = () => undefined
        const xAction = () => undefined
        const canCancel = true

        const popup = new ViewPopup(title, message, checkAction, xAction, canCancel)

        if(this.isSameErrorAlreadyBeingShown(popup)) return

        popup.show()
        popup.removeXButton()
        this.currentPopup = popup
    }

    static showMustBeMemberPopup(error: ErrorMustBeMember) {
        const defaultError: TranslationObject = {key: 'strings:popups.errors.general.title'}
        const title = error.title ?? defaultError
        const message = error.description

        const ctaOptions: ViewPopupOptions = {checkButtonCustomContent: {key: 'strings:popups.uhOh.checkButton'}}
        const url = UIDeviceController.isUserOnMobileAppOrWeb() ? '/mobile/store#membership' : '/store#membership'
        const ctaAction = () => navigateToPage(url)

        const popup = new ViewPopup(title, message, ctaAction, () => undefined, true, ctaOptions)

        if(this.isSameErrorAlreadyBeingShown(popup)) return

        popup.removeXButton()
        popup.show()
        this.currentPopup = popup
    }

    static showBlockingPopup(error: ErrorBlocking) {
        const defaultError: TranslationObject = {key: 'strings:popups.errors.general.title'}
        const title = error.title ?? defaultError
        const message = error.description

        const checkAction = () => undefined
        const xAction = () => undefined
        const canCancel = false

        const popup = new ViewPopup(title, message, checkAction, xAction, canCancel)

        if(this.isSameErrorAlreadyBeingShown(popup)) return

        popup.show()
        popup.removeXButton()
        popup.removeCheckButton()
        this.currentPopup = popup
    }

    private static isSameErrorAlreadyBeingShown(popup: ViewPopup): boolean {
        if(this.currentPopup?.isRemoved()) return false
        if(this.currentPopup?.body.innerHTML == popup.body.innerHTML) return true

        return false
    }
}

